import EllipsisMenu from "../../../../components/EllipsisMenu/EllipsisMenu"
import FileIcon from "../../../../media/FileIcon"
import { WorkflowFileProps } from "./WorkflowFile.types"
import "./WorkflowFile.css"
import { useState } from "react"

const WorkflowFile = (props: WorkflowFileProps) => {
  const { 
    isSelected,
    onClick,
    onSelect,
    pipeId,
    temperature,
    date,
    ellipsisMenu,
    enabled
  } = props

  const [showMenu, setShowMenu] = useState<boolean>(false)

  return (
    <div 
      className={`workflow-file-container ${isSelected ? "workflow-file-selected" : ""}`}
      onClick={enabled ? onSelect : () => {}}
      onDoubleClick={enabled ? onClick  : () => {}}
      style={{ opacity: enabled ? 1 : 0.4, cursor: enabled ? "pointer" : "wait" }}
    >
      <div className="pipe-id-container">
        <FileIcon />
        <p>{pipeId}</p>
      </div>

      <p>{temperature} °C</p>
      <p>{date}</p>
      <p>-</p>
      <div className="ellipsis-menu-container">
        <EllipsisMenu
          ellipsisMenu={
            {
              items: ellipsisMenu,
              showMenu: showMenu,
              onClick: () => enabled ? setShowMenu(true) : () => {},
              onHide: () => setShowMenu(false),
            } 
          }
        />
      </div>
    </div>
  )
}

WorkflowFile.defaultProps = {
  showHeader: false,
  isSelected: false
}

export default WorkflowFile